module.exports = __webpack_public_path__ + "static/media/kayvan-alikhani1-250x250.682b82e5.png";